<script setup>
// import fontRegular from "~/assets/font/NotoSansTC-Regular.woff2";
// import fontBold from "~/assets/font/NotoSansTC-Bold.woff2";

const nuxtApp = useNuxtApp();
const route = useRoute();
const router = useRouter();

const { startLoading, stopLoading } = useAppState();
const { setHeaderMode } = useMode();
const { locale } = useI18n();
const { fetchPage } = useFetchAPI();
const localePath = useLocalePath();

const previousPath = ref(route.path);
const nextPath = ref(route.path);

fetchPage("menu");
fetchPage("footer");

router.beforeEach((to, from) => {
    nextPath.value = to.path;
    previousPath.value = from.path;

    const isGplayToGplay =
        previousPath.value.includes("/gplay") &&
        nextPath.value.includes("/gplay");

    if (!isGplayToGplay) {
        setHeaderMode("light");
        startLoading();
    }

    return true;
});

nuxtApp.hook("page:loading:end", () => {
    const isGplayToGplay =
        previousPath.value.includes("/gplay") &&
        nextPath.value.includes("/gplay");

    if (nextPath.value.includes("/gplay"))
        setTimeout(
            () => setHeaderMode("dark"),
            previousPath.value.includes("/gplay") ? 1000 : 1500,
        );
    else if (nextPath.value.includes("/about")) setHeaderMode("silver");

    if (isGplayToGplay) stopLoading();
    else if (
        nextPath.value !== localePath("/") &&
        nextPath.value !== localePath("/search")
    ) {
        setTimeout(() => stopLoading(), 1000);
    }
});

const fontMapping = {
    zh: { href: "Noto+Sans+TC:wght@400;700", isLoaded: false },
    ja: { href: "Noto+Sans+JP:wght@400;700", isLoaded: false },
    ko: { href: "Noto+Sans+KR:wght@400;700", isLoaded: false },
};

watch(
    locale,
    (newLocale) => {
        if (newLocale !== "en") {
            const link = [];

            if (!fontMapping[newLocale].isLoaded) {
                link.push({
                    rel: "preload",
                    as: "style",
                    href: `https://fonts.googleapis.com/css2?family=${fontMapping[newLocale].href}&display=swap`,
                    onload: "this.onload=null;this.rel='stylesheet'",
                });
                fontMapping[newLocale].isLoaded = true;
            }

            useHead({
                htmlAttrs: {
                    lang: newLocale,
                },
                // custom font subset
                // link: [
                //     {
                //         rel: "preload",
                //         as: "font",
                //         type: "font/woff2",
                //         href: fontRegular,
                //         crossorigin: "anonymous",
                //     },
                //     {
                //         rel: "preload",
                //         as: "font",
                //         type: "font/woff2",
                //         href: fontBold,
                //         crossorigin: "anonymous",
                //     },
                // ],
                link,
            });
        } else {
            useHead({
                htmlAttrs: {
                    lang: newLocale,
                },
            });
        }
    },
    { immediate: true },
);
</script>

<template>
    <LoadingFrame />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
